import type {AnalyticsEvent} from 'analytics/Analytics';
import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import {CHAT_USE_CASE_CATEGORIES} from 'llm/chat-library/use-cases/chatUseCaseCatalog';

export const HOMEPAGE_AI_CHAT_BUTTON_IDS = [
  ...CHAT_USE_CASE_CATEGORIES.flatMap(({chatUseCases}) => chatUseCases.map(({id}) => id)),
  'something_else',
] as const;

export type HomepageAiChatButtonId = (typeof HOMEPAGE_AI_CHAT_BUTTON_IDS)[number];

function homepageAction(action: string, actionCategory: ACTION_CATEGORY): AnalyticsEvent {
  return {
    module: ANALYTICS_MODULE.NAVIGATION,
    action: `new_homepage_${action}`,
    actionCategory,
  };
}

function aiChatButtonAnalyticsKey(id: HomepageAiChatButtonId): string {
  return `CLICKED_AI_CHAT_BUTTON_${id.replace(/-/g, '_').toUpperCase()}`;
}

export const HOMEPAGE_AI_CHAT_BUTTON_ANALYTICS_ACTIONS_BY_ID: Record<HomepageAiChatButtonId, AnalyticsEvent> =
  {};
for (const id of HOMEPAGE_AI_CHAT_BUTTON_IDS) {
  HOMEPAGE_AI_CHAT_BUTTON_ANALYTICS_ACTIONS_BY_ID[id] = homepageAction(
    `ai_chat_button_clicked_${id}`,
    ACTION_CATEGORY.WRITE
  );
}

const HOMEPAGE_AI_CHAT_BUTTON_ANALYTICS_ACTIONS: Record<string, AnalyticsEvent> = {};
for (const id of HOMEPAGE_AI_CHAT_BUTTON_IDS) {
  HOMEPAGE_AI_CHAT_BUTTON_ANALYTICS_ACTIONS[aiChatButtonAnalyticsKey(id)] =
    HOMEPAGE_AI_CHAT_BUTTON_ANALYTICS_ACTIONS_BY_ID[id];
}

export const HOMEPAGE_ANALYTICS_ACTIONS = {
  CLICKED_CALENDAR_BUTTON: homepageAction('calendar_button_clicked', ACTION_CATEGORY.READ),
  CLICKED_CLOSE_BUTTON: homepageAction('close_button_clicked', ACTION_CATEGORY.READ),
  CLICKED_RECENT_ACTIVITY_TASK: homepageAction('recent_activity_task_clicked', ACTION_CATEGORY.READ),
  CLICKED_RECENT_FILE: homepageAction('recent_file_clicked', ACTION_CATEGORY.READ),
  CLICKED_MY_WORK_REVIEWABLE: homepageAction('my_work_reviewable_clicked', ACTION_CATEGORY.READ),
  CLICKED_MY_WORK_TASK: homepageAction('my_work_task_clicked', ACTION_CATEGORY.READ),
  CLICKED_MY_WORK_SEE_ALL_BUTTON: homepageAction('my_work_see_all_button_clicked', ACTION_CATEGORY.READ),
  CLICKED_RECENT_WORKLIST: homepageAction('recent_worklist_clicked', ACTION_CATEGORY.READ),
  SAVED_CARD_LAYOUT: homepageAction('card_layout_saved', ACTION_CATEGORY.WRITE),
  CLICKED_EXPLORE_MOLECULAR_BIOLOGY_BUTTON: homepageAction(
    'explore_molecular_biology_button_clicked',
    ACTION_CATEGORY.READ
  ),
  CLICKED_EXPLORE_NOTEBOOK_BUTTON: homepageAction('explore_notebook_button_clicked', ACTION_CATEGORY.READ),
  ...HOMEPAGE_AI_CHAT_BUTTON_ANALYTICS_ACTIONS,
};
